export default "__VITE_ASSET__DegUn9nM__"